module.exports = __webpack_public_path__ + "img/background.7b26202a.jpg";